import * as actionTypes from '../actions/actionTypes';

const initialState = {
  equipmentModels: { count: 0, rows: [] },
  equipmentModel: {},
  loadingEquipmentModels: false,
  loadingEquipmentServices: false,
  equipmentModelError: {},
};

const fetchEquipmentModelsReportsStart = (state) => {
  return {
    ...state,
    loadingEquipmentModels: true,
  }
}

const fetchEquipmentModelsReportsFail = (state, action) => {
  return {
    ...state,
    equipmentModelError: action.error,
    loadingEquipmentModels: false,
  }
}

const fetchEquipmentModelsReportsSuccess = (state, action) => {
  return {
    ...state,
    equipmentModels: action.equipmentModels,
    loadingEquipmentModels: false,
  }
}

const fetchEquipmentModelsReportsByIdStart = (state) => {
  return {
    ...state,
    loadingEquipmentServices: true,
  }
}

const fetchEquipmentModelsReportsByIdFail = (state, action) => {
  return {
    ...state,
    equipmentModelError: action.error,
    loadingEquipmentServices: false,
  }
}

const fetchEquipmentModelsReportsByIdSuccess = (state, action) => {
  return {
    ...state,
    equipmentModel: action.equipmentModel,
    loadingEquipmentServices: false,
  }
}

const clearSelectedEquipmentModelReports = (state) => {
  return {
    ...state,
    equipmentModel: {},
  }
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.REPORTS_FETCH_EQUIPMENT_MODELS_START: return fetchEquipmentModelsReportsStart(state);
    case actionTypes.REPORTS_FETCH_EQUIPMENT_MODELS_FAIL: return fetchEquipmentModelsReportsFail(state, action);
    case actionTypes.REPORTS_FETCH_EQUIPMENT_MODELS_SUCESS: return fetchEquipmentModelsReportsSuccess(state, action);
    case actionTypes.REPORTS_FETCH_EQUIPMENT_MODEL_BY_ID_START: return fetchEquipmentModelsReportsByIdStart(state);
    case actionTypes.REPORTS_FETCH_EQUIPMENT_MODEL_BY_ID_FAIL: return fetchEquipmentModelsReportsByIdFail(state, action);
    case actionTypes.REPORTS_FETCH_EQUIPMENT_MODEL_BY_ID_SUCCESS: return fetchEquipmentModelsReportsByIdSuccess(state, action);
    case actionTypes.REPORTS_CLEAR_SELECTED_EQUIPMENT_MODEL: return clearSelectedEquipmentModelReports(state);
    default: return state;
  }
}

export default reducer;
